

import * as actions from '../views/technician-dashboard-maintenances/assigned-maintenances.actions';
import * as actionsDailyQuestionaries from '../views/technician-dashboard-maintenances/daily-questionaries.actions';
import * as actionsLuminaries from '../views/list-luminaries/list-luminaries.actions';
import { ActionReducer } from '@ngrx/store';
import { SessionStore } from '../stores/session.store';
import { Capacitor } from '@capacitor/core';
import * as Sentry from "@sentry/angular-ivy";
import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';

const ASSIGNED_MAINTENANCES_REDUCERS_ACTIONS = [
    actions.saveQuestionary.type,
    actions.identifyLuminary.type,
    actions.setPhotosInitialState.type,
    actions.setPhotosFinalState.type,
    actions.setRepairmentData.type,
    actions.changeState.type,
    actions.sync.type,
    actions.normalizePhotos.type,
    actions.createMaintenance.type,
    actions.removeMaintenance.type
  ];

const DAILY_QUESTIONARIES_REDUCERS_ACTIONS = [
  actionsDailyQuestionaries.newQuestionary.type,
  actionsDailyQuestionaries.update.type,
];

const LUMINARY_REDUCERS_ACTIONS = [
  actionsLuminaries.create.type,
  actionsLuminaries.update.type,
  actionsLuminaries.remove.type
]

function isNative() {
    return Capacitor.getPlatform() !== 'web';
}
// console.log all actions
export function storeData(creducer: ActionReducer<any>): ActionReducer<any> {
  return function(state, action: any) {
    let storeName = '';
    const userId = SessionStore.getInstance().get()?.user.id;
    if (!userId) {
      return creducer(state, action);
    }
    if (ASSIGNED_MAINTENANCES_REDUCERS_ACTIONS.indexOf(action.type) >= 0 ) {
      storeName = `${userId}.assignedMaintenances`;
    } else if (DAILY_QUESTIONARIES_REDUCERS_ACTIONS.indexOf(action.type) >= 0 ) {
      storeName = `${userId}.dailyQuestionaries`;
    } else if (LUMINARY_REDUCERS_ACTIONS.indexOf(action.type) >= 0 ) {
      storeName = `${userId}.luminaries`;
    } else {
      return creducer(state, action);
    }

    const newState = creducer(state, action);
    const data:string | null = localStorage.getItem(storeName);
    let jsonData: any;
    if (data) {
      jsonData = JSON.parse(data);
    } else {
      jsonData = {};
    }

    jsonData.metadata = {...jsonData.metadata, ...{ timestamp: new Date().getTime(), manipulated: true } };
    jsonData.value = newState[storeName.split('.')[1]];
    try {
      const data =  JSON.stringify(jsonData);
      localStorage.setItem(storeName, data);
      if (isNative()) {
        Filesystem.writeFile({
            path: `${storeName}.json`,
            data: data,
            directory: Directory.Data,
            encoding: Encoding.UTF8,
        });
      }
      
    } catch(e) {
        Sentry.captureException(e);
    }

    return newState;
  };
}
